export default __webpack_public_path__ + "static/media/graduated.6d38c4a8.svg";